import { Box, FormControl, Grid, InputLabel, OutlinedInput, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

const Cell = styled(TableCell)({
    padding: '10px',
    fontWeight: 'bold',
});

const DisplaySelection = ({
    displayArr,
    setDisplayArr
}) => {
    return (
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ padding: '10px' }}>
            <Typography style={{ fontWeight: 'bold' }}>Selection</Typography>
            <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                <TableContainer>
                    <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                        <TableHead>
                            <TableRow>
                                <Cell>Quantity</Cell>
                                <Cell>Room Name</Cell>
                                <Cell>Department Name</Cell>
                                <Cell>Level Name</Cell>
                                <Cell>Building Name</Cell>
                                <Cell>Project Name</Cell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {displayArr.map((a) => (
                                <TableRow>
                                    <TableCell>
                                        <FormControl size="small" fullWidth variant="outlined">
                                            <InputLabel htmlFor="standard-adornment-password">Quantity</InputLabel>
                                            <OutlinedInput
                                                label="Quantity"
                                                type='number'
                                                value={a?.quantity || null}
                                                onChange={(e) => {
                                                    setDisplayArr((prevData) => {
                                                        return prevData.map((item) =>
                                                            item.room_id === a.room_id
                                                                ? { ...item, quantity: Number(e.target.value) }
                                                                : item
                                                        );
                                                    });
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        <FormControl size="small" fullWidth variant="outlined">
                                            <InputLabel htmlFor="standard-adornment-password">Room Name</InputLabel>
                                            <OutlinedInput
                                                label="Room Name"
                                                type='text'
                                                value={a?.room_name || null}
                                                onChange={(e) => {
                                                    setDisplayArr((prevData) => {
                                                        return prevData.map((item) =>
                                                            item.room_id === a.room_id
                                                                ? { ...item, room_name: e.target.value }
                                                                : item
                                                        );
                                                    });
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        {a?.department_name}
                                    </TableCell>
                                    <TableCell>
                                        {a?.level_name}
                                    </TableCell>
                                    <TableCell>
                                        {a?.building_name}
                                    </TableCell>
                                    <TableCell>
                                        {a?.project_name}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Grid>
    )
}

export default DisplaySelection;